import firestore, { FieldValue } from '../components/utils/firebase'

class BaseCollection {
  get collection () {
    return firestore.collection('__NONE__')
  }

  getDataFromDocumentData (doc) {
    if (doc.exists) {
      return {
        ...doc.data(),
        id: doc.id,
        objectId: doc.id
      }
    } else {
      return null
    }
  }

  all () {
    return this.collection
      .get()
      .then(q => q.docs.map(this.getDataFromDocumentData))
  }

  allIds () {
    return this.collection.get().then(q => q.docs.map(item => item.id))
  }

  findById (id) {
    return this.collection
      .doc(id)
      .get()
      .then(this.getDataFromDocumentData)
  }

  findByIdWithSnapshot (id, listener) {
    return this.collection
      .doc(id)
      .onSnapshot(listener)
  }

  add (obj) {
    return this.collection.add(obj).then(this.getDataFromDocumentData)
  }

  set (id, obj) {
    return this.collection.doc(id).set(obj)
  }

  update (id, obj) {
    return this.collection.doc(id).update(obj)
  }

  delete (id) {
    return this.collection.doc(id).delete()
  }
}

class UserCollection extends BaseCollection {
  get collection () {
    return firestore.collection('USER')
  }

  signUp (user, token) {
    if (!user.iconPhotoURL) {
      const defaultIconPhotoURL = 'https://firebasestorage.googleapis.com/v0/b/fir-tmp-project.appspot.com/o/public%2Faccount.png?alt=media&token=4ad2981f-61ac-42d9-a5ed-45eda74077d0'
      user.iconPhotoURL = defaultIconPhotoURL
    }
    if (!user.coverPhotoURL) {
      const defaultCoverPhotoURL = 'https://firebasestorage.googleapis.com/v0/b/fir-tmp-project.appspot.com/o/public%2Faccount.png?alt=media&token=4ad2981f-61ac-42d9-a5ed-45eda74077d0'
      user.coverPhotoURL = defaultCoverPhotoURL
    }
    if (token) {
      this.collection
        .doc(user.uid)
        .collection('SECRET')
        .doc(token.name)
        .set(token.value)
    }

    return this.collection
      .doc(user.uid)
      .set(user)
  }

  getAllOrderByDisplayName () {
    return this.collection
      .orderBy('displayName', 'asc')
      .get()
      .then(q => q.docs.map(d => {
        return { ...d.data(), id: d.id }
      }))
  }
}

class LicenseCollection extends BaseCollection {
  get collection () {
    return firestore.collection('LICENSE')
  }

  findByEmail (email) {
    return this.collection
      .where('email' , '==', email)
      .get()
      .then(q => q.docs.map(d => {
        return { ...d.data(), id: d.id }
      }))
  }
}

// class TmpCollection extends BaseCollection {
//   get collection () {
//     return firestore.collection('TMP')
//   }

//   getUserByUidWithSnapshot (uid, listener) {
//     return this.collection
//       .where('uid', '==', uid)
//       .onSnapshot(listener)
//   }
// }

/**
 * The whole database
 */
const database = {
  userCollection: () => new UserCollection(),
  licenseCollection: () => new LicenseCollection()
}

export default database
